import React from 'react';
import { User } from 'lucide-react';
import './ButtonPersona.css';

const ButtonPersona = ({ onClick, disabled = false }) => {
    return (
        <button className="boton-persona" onClick={onClick} disabled={disabled} title="Candidatos">
            <User />
        </button>
    );
};

export default ButtonPersona;